import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';

import { finalize, tap } from 'rxjs/operators';
import { MessageService } from '../message.service';
import { Observable } from 'rxjs';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class CorsInterceptor implements HttpInterceptor {
  // Static class variable to maintain the session csrftoken
  private csrftoken;
  private TokenName = 'X-CSRFToken';

  constructor(
    private messenger: MessageService,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler):
    Observable<HttpEvent<any>> {
      if (this.TokenName && this.csrftoken) {
        request = request.clone({
          headers: request.headers.set(this.TokenName, this.csrftoken)
        });
      }

      return next.handle(request)
        .pipe(
          tap(event => {
            if (event instanceof HttpResponse) {
              // CSRF token
              if (event.headers.get(this.TokenName)) {
                // If there is a csrftoken, capture it so it can be set on future responses
                this.csrftoken = event.headers.get(this.TokenName);
              }
            }
          })
        );
    }
}
